import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fireUser: null,
    loaded: 0,
    editable: false,
    site: {
      uid: localStorage.getItem('siteUid')
    },
    message: {
      public: {
        totalCount: localStorage.getItem('publicTotalCount') === undefined ? 0 : Number(localStorage.getItem('publicTotalCount')),
        readCount: localStorage.getItem('publicReadCount') === undefined ? 0 : Number(localStorage.getItem('publicReadCount'))
      }
    }
  },
  mutations: {
    setFireUser (state, fu) {
      state.fireUser = fu
      state.loaded++
    },
    setEditable (state, editable) {
      state.editable = editable
    },
    setSite (state, site) {
      if (site.uid) {
        state.site.uid = site.uid
        localStorage.setItem('siteUid', site.uid)
      }
    },
    setMessageTotalCount (state, { collection, count }) {
      localStorage.setItem(collection + 'TotalCount', count)
      if (state.message[collection] === null) state[collection] = {}
      state.message[collection].totalCount = count
    },
    setMessageReadCount (state, { collection, count }) {
      localStorage.setItem(collection + 'ReadCount', count)
      if (state.message[collection] === null) state[collection] = {}
      state.message[collection].readCount = count
    }
  },
  actions: {
  },
  modules: {
  }
})
